var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-list"},_vm._l((_vm.cases),function(caseItem,index){return _c('button',{key:index,class:{ active: caseItem === _vm.selectedCase },on:{"click":function($event){return _vm.handleCaseClick(caseItem)}}},[_vm._v(" "+_vm._s(caseItem.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }